export default {"src":"/_next/static/image/public/images/ic_legends.de2a4aa427006c6d6a18a03648cbf8da.svg","height":23,"width":112};